const s = {
  name: "Birdhouse",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.6 40" style="enable-background:new 0 0 39.6 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.7,0l19.9,19.5l-1.4,1.4L19.7,2.8L1.4,20.7L0,19.3L19.7,0z"/>
		<path class="st0" d="M14.7,23c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5C16.9,28,14.7,25.8,14.7,23z M19.7,20
			c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C22.7,21.3,21.4,20,19.7,20z"/>
		<path class="st0" d="M20.9,31c0,0.7-0.6,1.3-1.2,1.3c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.6-1.2,1.2-1.2C20.4,29.7,20.9,30.3,20.9,31z"
			/>
		<path class="st0" d="M19.7,5l14.1,13.6L29.9,38h3.5v2H5.7v-2h3.8L5.6,18.7L19.7,5z M11.5,38h16.4l3.7-18.7L19.7,7.8L7.8,19.3
			L11.5,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Birdhouse
};
